import { ILead } from 'src/interfaces/lead';
import { TAreas } from 'src/constants/lead/leadTypes';
import { getTemplateArea } from 'src/components/Lead/WhatsApp/utils/getTemplateArea';

/**
 * Store area the lead is messaged from: the area of its conversation or, when it
 * has none, the template area of the lead (same rule as `resolveConversationChannel`).
 */
export const getLeadAreaName = (lead: ILead): TAreas =>
    lead.conversation?.area || getTemplateArea(lead);
